import React from 'react';
import styles from './WorkQueue.module.scss';

function WorkQueueNameCell({ data, hideMyQueue = false }) {
  if (!data) return null;

  return (
    <div className={styles.nameCell}>
      <div className={styles.name}>
        <a href={data.show_path}>{data.name}</a>
        {data.queue_type === 'priority' && <span className={styles.typeBadge}>{I18n.t('work_queue_type_priority')}</span>}
        {data.is_member && !hideMyQueue && <span className={styles.ownBadge}>{I18n.t('work_queue_my_queue')}</span>}
      </div>
      {data.description && <div className={styles.description}>{data.description}</div>}
    </div>
  );
}

export default WorkQueueNameCell;
